(function () {
  "use strict";

  var COOLDOWN_BASE = 400;
  var COOLDOWN_STEP = 250;
  var COOLDOWN_MAX = 3000;
  var COOLDOWN_RESET = 2000;
  var MAX_RETRIES = 3;
  var BATCH_CONCURRENCY = 3;
  var AUTO_LOAD_CAP = 72;
  var OFFSCREEN_PX = 2500;
  var busy = false;
  var lastFetch = 0;
  var fetchBurst = 0;
  var autoLoaded = 0;
  var prefetchPx = (window.innerHeight || 800) * 2;
  var POLL_MS = 250;
  var userScrolled = false;
  var memoryIO = null;

  window.addEventListener("scroll", function () { userScrolled = true; }, { passive: true, once: true });

  function isSentinelNear(el) {
    if (!el || !el.isConnected || !userScrolled) return false;
    return el.getBoundingClientRect().top < window.innerHeight + prefetchPx;
  }

  /* Adaptive cooldown: ramps up during doomscroll, resets after pause */
  function cooldown(fn) {
    var now = Date.now();
    if (now - lastFetch > COOLDOWN_RESET) fetchBurst = 0;
    var delay = Math.min(COOLDOWN_BASE + fetchBurst * COOLDOWN_STEP, COOLDOWN_MAX);
    var wait = Math.max(0, delay - (now - lastFetch));
    fetchBurst++;
    if (wait) setTimeout(fn, wait); else fn();
  }


  /* -------------------------------------------------------
   *  MEMORY MANAGEMENT — unload images far offscreen
   * ------------------------------------------------------- */

  function initMemoryManager() {
    if (memoryIO || !window.IntersectionObserver) return;
    memoryIO = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var card = entries[i].target;
        var imgs = card.getElementsByTagName("img");
        var j;
        if (entries[i].isIntersecting) {
          for (j = 0; j < imgs.length; j++) {
            var savedSrc = imgs[j].getAttribute("data-ro-src");
            var savedSet = imgs[j].getAttribute("data-ro-srcset");
            if (savedSrc) { imgs[j].src = savedSrc; imgs[j].removeAttribute("data-ro-src"); }
            if (savedSet) { imgs[j].srcset = savedSet; imgs[j].removeAttribute("data-ro-srcset"); }
          }
        } else {
          for (j = 0; j < imgs.length; j++) {
            if (imgs[j].src && !imgs[j].hasAttribute("data-ro-src")) {
              imgs[j].setAttribute("data-ro-src", imgs[j].currentSrc || imgs[j].src);
              if (imgs[j].srcset) { imgs[j].setAttribute("data-ro-srcset", imgs[j].srcset); imgs[j].removeAttribute("srcset"); }
              imgs[j].removeAttribute("src");
            }
          }
        }
      }
    }, { rootMargin: OFFSCREEN_PX + "px 0px " + OFFSCREEN_PX + "px 0px" });
  }

  function observeCards(container) {
    if (!memoryIO) return;
    var cards = container.querySelectorAll ? container.querySelectorAll("product-card") : [];
    for (var i = 0; i < cards.length; i++) {
      if (!cards[i].hasAttribute("data-ro-mem")) {
        cards[i].setAttribute("data-ro-mem", "");
        memoryIO.observe(cards[i]);
      }
    }
  }

  /* -------------------------------------------------------
   *  LOAD-MORE GATE
   * ------------------------------------------------------- */

  function showLoadMoreGate(sentinel, onContinue) {
    var btn = document.createElement("button");
    btn.className = "ro-load-more-btn button button--primary";
    btn.textContent = "Mehr Produkte laden";
    btn.setAttribute("type", "button");
    btn.style.cssText = "display:block;margin:2rem auto;padding:.75rem 2rem;border-radius:2rem;cursor:pointer";
    btn.addEventListener("click", function () {
      autoLoaded = 0;
      fetchBurst = 0;
      btn.remove();
      sentinel.style.display = "";
      onContinue();
    });
    sentinel.style.display = "none";
    sentinel.parentNode.insertBefore(btn, sentinel);
  }

  function scheduleNext(sentinel, prepareAndBind) {
    autoLoaded += parseInt(sentinel.getAttribute("data-last-count") || "0", 10);
    if (autoLoaded >= AUTO_LOAD_CAP) {
      showLoadMoreGate(sentinel, function () {
        prepareAndBind();
      });
    } else {
      prepareAndBind();
    }
  }

  function knownHandles(list) {
    var map = {};
    var cards = list.getElementsByTagName("product-card");
    for (var i = 0; i < cards.length; i++) {
      var h = cards[i].getAttribute("handle");
      if (h) map[h] = true;
    }
    return map;
  }

  /* -------------------------------------------------------
   *  MANIFEST MODE — fetch individual cards by handle
   *  via the lightweight ro-product-card section
   * ------------------------------------------------------- */

  function fetchCardByHandle(handle) {
    var url = "/products/" + encodeURIComponent(handle) + "?sections=ro-product-card";
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (json) {
        var html = json["ro-product-card"] || "";
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, "text/html");
        var card = doc.querySelector("product-card");
        if (card) {
          card.removeAttribute("reveal-on-scroll");
          card.querySelectorAll("[reveal-on-scroll]").forEach(function (el) {
            el.removeAttribute("reveal-on-scroll");
          });
        }
        return card;
      })
      .catch(function () { return null; });
  }

  function fetchBatch(handles) {
    var results = new Array(handles.length);
    var queue = handles.slice();
    var idx = 0;

    return new Promise(function (resolve) {
      var inflight = 0;
      function next() {
        while (inflight < BATCH_CONCURRENCY && idx < queue.length) {
          (function (i) {
            inflight++;
            fetchCardByHandle(queue[i]).then(function (card) {
              results[i] = card;
              inflight--;
              next();
            });
          })(idx);
          idx++;
        }
        if (inflight === 0) resolve(results);
      }
      next();
    });
  }

  function loadManifestBatch(sentinel) {
    if (busy) return;
    busy = true;

    var sectionId = sentinel.getAttribute("data-section-id");
    var pageSize = parseInt(sentinel.getAttribute("data-page-size") || "16", 10);
    var offset = parseInt(sentinel.getAttribute("data-offset") || "0", 10);

    var sec = document.getElementById("shopify-section-" + sectionId);
    if (!sec) { busy = false; return; }
    var list = sec.querySelector(".collection__results product-list");
    if (!list) { busy = false; return; }

    var manifestEl = document.getElementById("ro-manifest-" + sectionId);
    if (!manifestEl) { busy = false; sentinel.remove(); return; }

    var handles;
    try { handles = JSON.parse(manifestEl.textContent); } catch (e) { busy = false; sentinel.remove(); return; }

    var batch = handles.slice(offset, offset + pageSize);
    if (batch.length === 0) { busy = false; sentinel.remove(); return; }

    var nextOffset = offset + pageSize;
    var hasMore = nextOffset < handles.length;

    lastFetch = Date.now();

    var seen = knownHandles(list);
    var needed = batch.filter(function (h) { return !seen[h]; });

    if (needed.length === 0) {
      busy = false;
      if (hasMore) {
        sentinel.setAttribute("data-last-count", String(batch.length));
        scheduleNext(sentinel, function () {
          sentinel.setAttribute("data-offset", String(nextOffset));
          sentinel.removeAttribute("data-ro-bound");
          cooldown(function () { bindOne(sentinel); });
        });
      } else {
        sentinel.remove();
      }
      return;
    }

    fetchBatch(needed).then(function (cards) {
      busy = false;
      if (!sentinel.isConnected) return;

      var frag = document.createDocumentFragment();
      var count = 0;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i]) { frag.appendChild(cards[i]); count++; }
      }
      if (frag.firstChild) { list.appendChild(frag); observeCards(list); }

      if (hasMore) {
        sentinel.setAttribute("data-last-count", String(count));
        scheduleNext(sentinel, function () {
          sentinel.setAttribute("data-offset", String(nextOffset));
          sentinel.removeAttribute("data-ro-bound");
          cooldown(function () { bindOne(sentinel); });
        });
      } else {
        sentinel.remove();
      }
    });
  }

  /* -------------------------------------------------------
   *  NORMAL infinite scroll (non-presort collections)
   * ------------------------------------------------------- */

  function loadNext(sentinel) {
    if (busy) return;
    var sectionId = sentinel.getAttribute("data-section-id");
    var nextUrl = sentinel.getAttribute("data-next-url");
    if (!nextUrl) { sentinel.remove(); return; }

    var retries = parseInt(sentinel.getAttribute("data-retries") || "0", 10);
    if (retries >= MAX_RETRIES) { sentinel.remove(); return; }

    var sec = document.getElementById("shopify-section-" + sectionId);
    if (!sec) return;
    var list = sec.querySelector(".collection__results product-list");
    if (!list) return;

    var url = new URL(nextUrl, window.location.origin);
    url.searchParams.set("section_id", sectionId);

    busy = true;
    lastFetch = Date.now();
    fetch(url.toString(), { credentials: "same-origin" })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        busy = false;
        if (!sentinel.isConnected) return;

        var doc = new DOMParser().parseFromString(html, "text/html");
        var newSec = doc.getElementById("shopify-section-" + sectionId) || doc.querySelector(".shopify-section");
        if (!newSec) { sentinel.remove(); return; }
        var newList = newSec.querySelector(".collection__results product-list");
        if (!newList) { sentinel.remove(); return; }

        var seen = knownHandles(list);
        var frag = document.createDocumentFragment();
        var child = newList.firstElementChild;
        while (child) {
          var next = child.nextElementSibling;
          if (child.nodeName.toLowerCase() === "product-card") {
            var h = child.getAttribute("handle");
            if (!h || !seen[h]) {
              if (h) seen[h] = true;
              child.removeAttribute("reveal-on-scroll");
              child.querySelectorAll("[reveal-on-scroll]").forEach(function (el) {
                el.removeAttribute("reveal-on-scroll");
              });
              frag.appendChild(child);
            }
          }
          child = next;
        }
        var appendedCount = 0;
        if (frag.firstChild) { appendedCount = frag.childNodes.length; list.appendChild(frag); observeCards(list); }

        sentinel.remove();

        var newSentinel = newSec.querySelector("[data-ro-collection-infinite]");
        if (newSentinel) {
          newSentinel.removeAttribute("data-ro-bound");
          newSentinel.removeAttribute("data-retries");
          list.insertAdjacentElement("afterend", newSentinel);
          newSentinel.setAttribute("data-last-count", String(appendedCount));
          scheduleNext(newSentinel, function () {
            cooldown(function () { bindOne(newSentinel); });
          });
        }
      })
      .catch(function () {
        busy = false;
        if (!sentinel.isConnected) return;
        sentinel.setAttribute("data-retries", String(retries + 1));
        var delay = Math.min(1000 * Math.pow(2, retries), 8000);
        setTimeout(function () { bindOne(sentinel); }, delay);
      });
  }

  /* -------------------------------------------------------
   *  SENTINEL BINDING
   * ------------------------------------------------------- */

  function bindOne(sentinel) {
    if (sentinel.hasAttribute("data-ro-bound")) return;
    sentinel.setAttribute("data-ro-bound", "");

    var isManifest = sentinel.hasAttribute("data-ro-manifest");
    var active = true;

    function trigger() {
      if (!active || busy) return;
      active = false;
      if (isManifest) {
        loadManifestBatch(sentinel);
      } else {
        loadNext(sentinel);
      }
    }

    function recheck() {
      if (!active || busy || !sentinel.isConnected) return;
      if (isSentinelNear(sentinel)) trigger();
    }

    var pollId = setInterval(function () {
      if (!sentinel.isConnected) { clearInterval(pollId); return; }
      recheck();
    }, POLL_MS);

    window.addEventListener("scroll", recheck, { passive: true });

    try {
      new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) trigger();
      }, { rootMargin: prefetchPx + "px 0px " + prefetchPx + "px 0px", threshold: 0 }).observe(sentinel);
    } catch (e) {}

    if (isSentinelNear(sentinel)) cooldown(trigger);
  }

  function bindAll() {
    initMemoryManager();
    var lists = document.querySelectorAll(".collection__results product-list");
    for (var i = 0; i < lists.length; i++) observeCards(lists[i]);
    var els = document.querySelectorAll("[data-ro-collection-infinite]:not([data-ro-bound])");
    els.forEach(bindOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bindAll);
  } else {
    bindAll();
  }

  document.documentElement.addEventListener("theme:loading:end", function () {
    busy = false;
    autoLoaded = 0;
    fetchBurst = 0;
    bindAll();
    setTimeout(bindAll, 0);
    requestAnimationFrame(bindAll);
  });

  /* MutationObserver: pick up sentinels injected after facet / filter DOM replacements.
     Uses a debounced bindAll so scheduleNext / showLoadMoreGate finish first. */
  var pendingMOBind = null;
  try {
    new MutationObserver(function (mutations) {
      if (pendingMOBind) return;
      var dominated = false;
      for (var i = 0; !dominated && i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if ((node.hasAttribute && node.hasAttribute("data-ro-collection-infinite")) ||
              (node.querySelector && node.querySelector("[data-ro-collection-infinite]"))) {
            dominated = true;
            break;
          }
        }
      }
      if (dominated) {
        pendingMOBind = setTimeout(function () {
          pendingMOBind = null;
          busy = false;
          bindAll();
        }, 80);
      }
    }).observe(document.body, { childList: true, subtree: true });
  } catch (e) {}

  /* -------------------------------------------------------
   *  DEFERRED MEDIA — hydrate images 3+ on first interaction
   * ------------------------------------------------------- */

  function hydrateDeferred(wrapper) {
    var tpl = wrapper.querySelector("template.product-card__deferred-media");
    if (!tpl) return;
    var scroll = wrapper.querySelector(".product-card__media-scroll");
    if (scroll) scroll.appendChild(tpl.content);
    tpl.remove();
  }

  function onCardInteract(e) {
    var w = e.target.closest(".product-card__media-scroll-wrapper");
    if (w) hydrateDeferred(w);
  }

  document.addEventListener("touchstart", onCardInteract, { passive: true });
  document.addEventListener("mouseover", onCardInteract, { passive: true });
})();
